module.exports = __webpack_public_path__ + "static/media/CGSE_Hero_Germany.62dd6535.jpg";